import styled from 'styled-components';

export const Container = styled.div<{ radarType: string }>`
    display: flex;
    justify-content: center;
    .recharts-radar-polygon .recharts-polygon {
        display: ${(p) => p.radarType === 'dotted' && 'none'};
    }
`;
